export default __webpack_public_path__ + "static/media/legal-team-defendant2-legal-team-defendant.d117d188.jpg";